import { getBodySelectedData, setBodySelectedData } from './BodyAdapter';
import { getSubjectSelectedData, setSubjectSelectedData } from './SubjectAdapter';
import { SelectedData } from 'owa-addins-core';
import { ComposeViewState } from 'owa-mail-compose-store';
import { ComposeControl } from 'owa-mail-compose-store/lib/utils/getAutoFocusControl';

export const getSelectedData = (viewState: ComposeViewState) => (): SelectedData => {
    if (viewState.lastFocusedControl === ComposeControl.Editor) {
        return getBodySelectedData(viewState)();
    } else if (viewState.lastFocusedControl === ComposeControl.SubjectLine) {
        return getSubjectSelectedData(viewState)();
    }

    return null;
};

export const setSelectedData = (viewState: ComposeViewState) => (content: string) => {
    if (viewState.lastFocusedControl === ComposeControl.Editor) {
        setBodySelectedData(viewState)(content);
    } else if (viewState.lastFocusedControl === ComposeControl.SubjectLine) {
        setSubjectSelectedData(viewState)(content);
    }

    return;
};
